module.exports = __webpack_public_path__ + "static/media/fishingarea.09885873.svg";